<template>
    <div class="modal-card card">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">Edit Parameter Values</h4>
            <!-- Close -->
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="card-body">
            <div class="table-responsive">
                <table class="table table-sm table-nowrap mt-2">
                    <thead>
                        <tr class="">
                            <th class="col-sm-4">Name</th>
                            <th class="col-sm-3">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(param, index) in parameters" :key="index">
                            <td class="col-sm-4 px-1 py-2">
                                <input style="padding: 2px 7px;" class="form-control" type="text" :disabled=true
                                    v-model="parameters[index].name" />
                            </td>
                            <td class="col-sm-3 px-1 py-2">
                                <input style="padding: 2px 7px;" class="form-control" type="text"
                                    v-model="parameters[index].value" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card-footer text-end">
            <button class="btn btn-success" :disabled="saving" @click="saveParameters">
                <div v-if="saving" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <div v-else>
                    Save
                </div>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {
            parameters: [],
            saving: false
        }
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    beforeMount() {
        this.parameters = JSON.parse(JSON.stringify(this.$store.state.amdp.lakeviewParameters)) // deep clone
    },
    methods: {
        ...mapActions({
            fetchParameters: "amdp/fetchLakeviewParameters",
            updateParameters: "amdp/updateLakeviewParameters"
        }),
        async saveParameters() {
            this.saving = true;
            let toastOptions;
            await this.updateParameters({
                sandboxName: `${this.$route.params.sandboxId}`,
                jobName: `${this.$route.params.jobId}`,
                payload: {
                    parameters: this.parameters
                }
            })
                .then(() => {
                    toastOptions = {
                        message: "Default values updated successfully.",
                        type: "success",
                    };
                    this.fetchParameters({
                        sandboxName: `${this.$route.params.sandboxId}`,
                        jobName: `${this.$route.params.jobId}`
                    });
                    this.$store.dispatch('hideModal')
                })
                .catch((error) => {
                    let err = "";
                    if (error.response.data.error)
                        err = error.response.data.error
                    else
                        err = error.message

                    toastOptions = {
                        message: err || "Something went wrong when updating parameters. Please contact support.",
                        type: "error",
                    };
                    return;
                }).finally(() => {
                    this.$store.dispatch("addToast", toastOptions);   
                    this.saving = false;
                })
        }
    }
}
</script>

<style></style>